import ScaleText from "react-scale-text"
import CloseButton from "../../../components/CloseButton/CloseButton"
import { useAppState } from "../../../context/appStateContext"
import useStrings from "../../../localization/useStrings"
import native from "../../../native/native"
import svg from "../../../utils/svg"
import styles from "./Header.module.scss"
import useExistingUserPromo from "../../../hooks/useExistingUserPromo"

const Header = () => {
  const strings = useStrings()
  const savingPercentage = useExistingUserPromo().pricing.savingPercent

  const { initialData } = useAppState().state

  const title = strings.emailPromo.title
  const topInset = initialData?.topInset ?? 0

  return (
    <div className={styles.container}>
      <div style={{ height: topInset }} />
      <div className={styles.titleContainer}>
        <ScaleText>
          <label className={styles.title}>{title}</label>
        </ScaleText>
        <CloseButton
          onClick={() => {
            native.postNativeEvent("close")
          }}
        />
      </div>
      <div className={styles.subtitleContainer}>
        <label className={styles.savingValue}>{savingPercentage}</label>
        <div className={styles.offContainer}>
          <label className={styles.savingPercent}>%</label>
          <label className={styles.savingOff}>{strings.off}</label>
        </div>
      </div>
      <div className={styles.goUltimateContainer}>
        <label>{strings.emailPromo.upgradeButton}</label>
        <svg.PremiumIcon width={20} height={16} fill="white" />
      </div>
    </div>
  )
}

export default Header
